// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  position: relative;
}
.home-container .spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.home-container h1 {
  font-size: 2.09vw;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 1.875rem;
}

.user-name h1 {
  font-size: 2.09vw;
  font-weight: 400;
  line-height: 2.09vw;
  color: #3a3a3a;
  margin-top: 3.816vw;
}

.user-name p {
  font-size: 0.90243vw;
  font-weight: 400;
  line-height: 1.665vw;
  color: #3a3a3a;
}

.user-name {
  margin-bottom: 1.11vw;
  margin-top: 2.91375vw;
}

.build-virtual-reality {
  margin: 2.22vw 0;
}

.pick-subscription-plan {
  display: flex;
  justify-content: space-between;
  letter-spacing: 2%;
  padding: 0.25vw 1.11vw;
  align-items: center;
  width: 53.35vw;
  height: 4.18vw;
  background-color: #fff;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 3px;
  opacity: 90%;
  margin-bottom: 1.5rem;
}

.step-container {
  padding-top: 1.5vw;
}

.step_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.11vw;
  background-color: #fff;
  border-radius: 3px;
  opacity: 90%;
  width: 58.55vw;
  margin: -1.5vw 0;
  cursor: pointer;
}

.step_box > span {
  opacity: 0.2;
}

.step-active .step_box > span {
  opacity: 1;
}

.step:not(.step-not-active) .step_box > span {
  opacity: 1;
}

.step:not(.step-not-active) .circle {
  cursor: pointer;
}

.pick-subscription-plan p,
.continue-btn {
  font-weight: 500;
  font-size: 0.91vw;
  line-height: 1.24875vw;
}

.continue-btn {
  background-color: #ee3a24;
  border-radius: 3px;
  padding: 0.8325vw 2.775vw;
  border: none;
  color: #fff;
}

.continue-btn span {
  margin: 0 0.25rem;
}

.step {
  position: relative;
  height: 4.87vw;
  color: #3a3a3a;
}

.title {
  line-height: 1.24875vw;
  font-weight: 500;
  font-size: 1.05vw;
  margin-bottom: 0.25vw;
}

.caption {
  font-size: 0.906vw;
  line-height: 1.24875vw;
  margin-top: 0.25vw;
}

.step + .step {
  margin-top: 1.11vw;
}

.step > div:first-child {
  position: static;
  height: 0;
}

.step > div:not(:first-child) {
  margin-left: 3vw;
}

.circle {
  background: rgba(238, 58, 36, 0.1803921569);
  position: relative;
  width: 2.08125vw;
  height: 2.08125vw;
  line-height: 2.2vw;
  border-radius: 100%;
  color: #ee3a24;
  text-align: center;
  cursor: pointer;
}

.step.step-not-active .circle {
  border: 0.027vw solid #ee3a24;
  background-color: transparent;
}

.circle:after {
  content: " ";
  display: block;
  margin-top: -1.45743vw;
  margin-right: 50%;
  bottom: 0.06993vw;
  margin-left: 50%;
  height: 100%;
  width: 0.06993vw;
  transform: scale(1, 1.88);
  transform-origin: 50% -66%;
  background-color: rgba(238, 58, 36, 0.1803921569);
  z-index: -1;
}

.step:last-child .circle:after {
  display: none;
}

.step.step-active {
  color: #3a3a3a;
}

.step.step-active .circle {
  background-color: #ee3a24;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/style/pages/dashboard/Homepage.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAEJ;;AACA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAEF;;AAAA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAGF;;AADA;EACE,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAIF;;AAFA;EACE,qBAAA;EACA,qBAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,+DAAA;EAEA,kBAAA;EACA,YAAA;EACA,qBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AALA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAQF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,UAAA;AAUF;;AARA;EACE,UAAA;AAWF;;AATA;EACE,eAAA;AAYF;;AAVA;;EAEE,gBAAA;EACA,iBAAA;EACA,sBAAA;AAaF;;AAVA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AAaF;;AAXA;EACE,iBAAA;AAcF;;AAZA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;AAeF;;AAbA;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAgBF;;AAdA;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;AAiBF;;AAfA;EACE,kBAAA;AAkBF;;AAhBA;EACE,gBAAA;EACA,SAAA;AAmBF;;AAjBA;EACE,gBAAA;AAoBF;;AAlBA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAqBF;;AAnBA;EACE,6BAAA;EACA,6BAAA;AAsBF;;AApBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iDAAA;EACA,WAAA;AAuBF;;AArBA;EACE,aAAA;AAwBF;;AAtBA;EACE,cAAA;AAyBF;;AAvBA;EACE,yBAAA;EACA,WAAA;AA0BF","sourcesContent":[".home-container {\n  position: relative;\n  .spinner-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n.home-container h1 {\n  font-size: 2.09vw;\n  font-weight: 400;\n  color: #3a3a3a;\n  line-height: 1.875rem;\n}\n.user-name h1 {\n  font-size: 2.09vw;\n  font-weight: 400;\n  line-height: 2.09vw;\n  color: #3a3a3a;\n  margin-top: 3.816vw;\n}\n.user-name p {\n  font-size: 0.90243vw;\n  font-weight: 400;\n  line-height: 1.665vw;\n  color: #3a3a3a;\n}\n.user-name {\n  margin-bottom: 1.11vw;\n  margin-top: 2.91375vw;\n}\n.build-virtual-reality {\n  margin: 2.22vw 0;\n}\n.pick-subscription-plan {\n  display: flex;\n  justify-content: space-between;\n  letter-spacing: 2%;\n  padding: 0.25vw 1.11vw;\n  align-items: center;\n  width: 53.35vw;\n  height: 4.18vw;\n  background-color: #fff;\n  box-shadow: 0px 4px 7.4px 0px #bebebe40;\n\n  border-radius: 3px;\n  opacity: 90%;\n  margin-bottom: 1.5rem;\n}\n.step-container {\n  padding-top: 1.5vw;\n}\n.step_box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.11vw;\n  background-color: #fff;\n  border-radius: 3px;\n  opacity: 90%;\n  width: 58.55vw;\n  margin: -1.5vw 0;\n  cursor: pointer;\n}\n.step_box > span {\n  opacity: .2;\n}\n.step-active .step_box > span {\n  opacity: 1;\n}\n.step:not(.step-not-active) .step_box > span {\n  opacity: 1;\n}\n.step:not(.step-not-active) .circle {\n  cursor: pointer;\n}\n.pick-subscription-plan p,\n.continue-btn {\n  font-weight: 500;\n  font-size: 0.91vw;\n  line-height: 1.24875vw;\n}\n\n.continue-btn {\n  background-color: #ee3a24;\n  border-radius: 3px;\n  padding: 0.8325vw 2.775vw;\n  border: none;\n  color: #fff;\n}\n.continue-btn span {\n  margin: 0 0.25rem;\n}\n.step {\n  position: relative;\n  height: 4.87vw;\n  color: #3a3a3a;\n}\n.title {\n  line-height: 1.24875vw;\n  font-weight: 500;\n  font-size: 1.05vw;\n  margin-bottom: 0.25vw;\n}\n.caption {\n  font-size: 0.906vw;\n  line-height: 1.24875vw;\n  margin-top: 0.25vw;\n}\n.step + .step {\n  margin-top: 1.11vw;\n}\n.step > div:first-child {\n  position: static;\n  height: 0;\n}\n.step > div:not(:first-child) {\n  margin-left: 3vw;\n}\n.circle {\n  background: #ee3a242e;\n  position: relative;\n  width: 2.08125vw;\n  height: 2.08125vw;\n  line-height: 2.2vw;\n  border-radius: 100%;\n  color: #ee3a24;\n  text-align: center;\n  cursor: pointer;\n}\n.step.step-not-active .circle {\n  border: 0.027vw solid #ee3a24;\n  background-color: transparent;\n}\n.circle:after {\n  content: \" \";\n  display: block;\n  margin-top: -1.45743vw;\n  margin-right: 50%;\n  bottom: 0.06993vw;\n  margin-left: 50%;\n  height: 100%;\n  width: 0.06993vw;\n  transform: scale(1, 1.88);\n  transform-origin: 50% -66%;\n  background-color: #ee3a242e;\n  z-index: -1;\n}\n.step:last-child .circle:after {\n  display: none;\n}\n.step.step-active {\n  color: #3a3a3a;\n}\n.step.step-active .circle {\n  background-color: #ee3a24;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
